"use client";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/FeatureLine/Card.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Card = ({ icon, title, description }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-center items-center first:w-full md:w-full xxs:w-[calc(50%-16px)] md:max-w-[170px] lg:max-w-[250px] flex-col", children: [
    /* @__PURE__ */ jsx(Icon_default, { name: icon, className: "w-40 h-40 text-stone-500 fill-current" }),
    title && /* @__PURE__ */ jsx(
      "h6",
      {
        dangerouslySetInnerHTML: {
          __html: title
        },
        className: "text-center text-base mt-16"
      }
    ),
    description && /* @__PURE__ */ jsx(
      "p",
      {
        dangerouslySetInnerHTML: {
          __html: description
        },
        className: "text-center text-base"
      }
    )
  ] });
};

export {
  Card
};
